import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';

import logoLarge1x from 'images/nlauncher-logo-72dpi-238w.png';
import logoLarge2x from 'images/nlauncher-logo-144dpi-476w.png';
import logoSmall1x from 'images/nlauncher-logo-72dpi-159w.png';
import logoSmall2x from 'images/nlauncher-logo-144dpi-317w.png';
import iconSmall1x from 'images/nlauncher-icon-72dpi-55w.png';
import iconSmall2x from 'images/nlauncher-icon-144dpi-109w.png';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      '&.small': {
        width: 120,
        height: theme.pageHeaderHeight
      },
      '&.large': {
        width: 238
      }
    },
    collapse: {
      '&.small': {
        width: 55
      }
    },
    logoImage: {
      width: '100%'
    },
    iconText: {
      transition: theme.transitions.create('opacity')
    }
  }),
  { withTheme: true }
);

export default function ({ size = 'small', collapse }) {
  const classes = useStyles();
  const srcSetList = {
    large: `${logoLarge1x}, ${logoLarge2x} 2x`,
    small: `${logoSmall1x}, ${logoSmall2x} 2x`
  };
  const srcSetDefault = {
    large: `${logoLarge1x}`,
    small: `${logoSmall1x}`
  };

  if (collapse) {
    srcSetList.small = `${iconSmall1x}, ${iconSmall2x} 2x`;
    srcSetDefault.small = `${iconSmall1x}`;
  }

  return (
    <header
      className={classNames(classes.root, size, {
        [classes.collapse]: collapse
      })}
      data-testid="app-logo"
    >
      <img
        className={classes.logoImage}
        srcSet={srcSetList[size]}
        src={srcSetDefault[size]}
        alt="nLauncher"
      />
    </header>
  );
}
